import { Tooltip } from "@visx/tooltip";
import { isEmpty } from "lodash/fp";

import {
  Block,
  Marker,
  Segment,
} from "@app/analytics/components/PlayerControls/types";
import VideoAnnotation from "@app/analytics/components/VideoAnnotation";

import { Column } from "@rui/Stack";

import {
  TooltipContent,
  TooltipContentRow,
  TooltipDescription,
  TooltipDivider,
} from "./styles";

interface ScrubberBarTooltip {
  segment?: Segment;
  blocks?: Block[];
  /** Whether the tooltip should be flipped along its y-axis */
  invert?: boolean;
  markers?: Marker[];
  x?: number;
}

const ScrubberBarTooltip = ({
  segment,
  blocks = [],
  invert,
  markers = [],
  x,
}: ScrubberBarTooltip) => {
  if (isEmpty(blocks) && isEmpty(markers) && isEmpty(segment)) return null;

  const left = (x ?? 0) + (invert ? 12 : -12);

  const showDivider = segment && (!isEmpty(blocks) || !isEmpty(markers));

  const isUpsellPreview =
    (blocks[0]?.id ?? markers[0]?.id)?.startsWith("preview") ?? false;

  if (isUpsellPreview) {
    return (
      <Column sx={{ position: "absolute", top: -12, left }}>
        <Tooltip style={{ padding: 0, pointerEvents: "none", zIndex: 100 }}>
          <TooltipContent
            sx={{
              transform: invert
                ? "translate3d(-100%, -100%, 0)"
                : "translate3d(0, -100%, 0)",
            }}
          >
            <TooltipContentRow>
              <TooltipDescription>
                Upgrade to view highlights
              </TooltipDescription>
            </TooltipContentRow>
          </TooltipContent>
        </Tooltip>
      </Column>
    );
  }

  return (
    <Column sx={{ position: "absolute", top: -12, left }}>
      <Tooltip style={{ padding: 0, pointerEvents: "none", zIndex: 100 }}>
        <TooltipContent
          sx={{
            transform: invert
              ? "translate3d(-100%, -100%, 0)"
              : "translate3d(0, -100%, 0)",
          }}
        >
          {segment && (
            <TooltipContentRow>
              <TooltipDescription>{segment.label}</TooltipDescription>
            </TooltipContentRow>
          )}
          {showDivider && <TooltipDivider />}
          {markers.map((marker) => (
            <VideoAnnotation
              key={marker.id}
              bgcolor={marker.bgcolor}
              color={marker.color}
              label={marker.label}
              description={marker.description}
              variant="circle"
            />
          ))}
          {blocks.map((block) => (
            <VideoAnnotation
              key={block.id}
              color={block.color}
              label={block.label}
              description={block.description}
              variant="square"
            />
          ))}
        </TooltipContent>
      </Tooltip>
    </Column>
  );
};

export default ScrubberBarTooltip;
